export default __webpack_public_path__ + "static/media/Setting_HeroUS.6963bd81.svg";